<template>
  <a :href="href" :class="{ 'arrow-link--big': big }" class="arrow-link">
    <span class="arrow-link__arrow">→ </span>
    <span class="arrow-link__text"><slot/></span>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '#'
    },
    big: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .arrow-link {
    @include text;
    @include reset-link;

    display: inline-block;

    &__arrow {
      display: inline-block;
      vertical-align: middle;

      margin-top: -0.0625em;
      padding-right: 0.3em;
    }

    &--big {
      @include text(big, medium);
    }

    &__text {
      display: inline-block;
      transition: transform $base-transition;
    }

    &:hover &__text {
      transform: translate3d(0.325em, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ArrowLink.vue